
import { vmrsGet, vmrsPost } from "./vmrsApi";

export async function search(payload: any)
{
  return vmrsPost(`/api/v1/search?provider_code=${payload?.provider_code}`, payload);
}

export async function getProvider(payload?: any)
{
  return vmrsGet(`/api/v1/providers`);
}


export async function getImageTypes()
{

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.get(`${baseUrl}${withServicePrefix("/api/v1/configs/category/satellite_image_type?with_providers=true")}`);
  return vmrsGet("/api/v1/configs/category/satellite_image_type?with_providers=true")
}



export async function getFormSearchByImageType(payload?: any)
{

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.get(`${baseUrl}${withServicePrefix(`/api/v1/form-configs/search-form/key/${payload?.key}`)}`);
  return vmrsGet(`/api/v1/form-configs/search-form/key/${payload?.key}`)
}



